@if (item) {
  <div class="cms-chapter-container">
    @if (contentEdit) {
      <coin-v2-text-input
        [label]="'cms.content-pages.chapter-icon' | translate"
        [placeholder]="'cms.content-pages.chapter-icon' | translate"
        [(ngModel)]="item.content.icon" />
    }
    @if (contentEdit) {
      <coin-v2-text-input
        [label]="'cms.content-pages.chapter-text' | translate"
        [placeholder]="'cms.content-pages.chapter-text' | translate"
        [(ngModel)]="item.content.text" />
    }
    <div class="cms-chapter-checks">
      @if (contentEdit) {
        <coin-v2-checkbox
          [label]="'cms.content-pages.show-print-page-button' | translate"
          [(ngModel)]="item.content['showPrintButton']" />
      }
      @if (contentEdit) {
        <coin-v2-checkbox
          [label]="'cms.content-pages.show-germany-row-button' | translate"
          [(ngModel)]="item.content['showGermanyRowButton']" />
      }
      @if (contentEdit) {
        <coin-v2-checkbox
          [label]="'cms.content-pages.requires-authentication' | translate"
          [(ngModel)]="item.requiresAuthentication"></coin-v2-checkbox>
      }
    </div>
  </div>
}

@if (item) {
  <div
    class="cms-chapter-main"
    [id]="item?.id ?? ''">
    <div>
      <div class="chapter-icon">
        <span class="material-icons-outlined">{{ item?.content.icon || 'view_in_ar' }}</span>
      </div>
      <p class="cms-chapter-text">{{ item?.content.text }}</p>
    </div>
    <div>
      @if (item.content['showGermanyRowButton']) {
        <div class="cp-slide-toggle">
          <p>{{ 'general.germany' | translate }}</p>
          <mat-slide-toggle
            [checked]="germanyRowSlideToggle"
            (change)="slideChange.emit($event)"></mat-slide-toggle>
          <p>ROW</p>
        </div>
      }
      @if (item.content['showPrintButton']) {
        <coin-v2-button
          type="secondary"
          class="cms-chapter-print"
          icon="print"
          [text]="'general.print' | translate"
          (click)="printPage()"></coin-v2-button>
      }
    </div>
  </div>
}
